import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { type RouteLocationResolved, useRouter } from 'vue-router';

export const isFullUrl = (uri?: string): boolean => uri?.startsWith('https://') ?? false;

const useParsedUri = (
  givenUri: MaybeRefOrGetter<string | undefined>,
) => {
  const router = useRouter();

  const href = computed<string | undefined>(() => {
    const uri = toValue(givenUri);

    return isFullUrl(uri) ? uri : undefined;
  });

  const to = computed<RouteLocationResolved | undefined>(() => {
    const uri = toValue(givenUri);

    return uri && !isFullUrl(uri) ? router.resolve(uri) : undefined;
  });

  return { href, to };
};

export default useParsedUri;
